export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100/50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <div className="bg-background-50 border border-background-200/60 rounded-xl p-8 md:p-10">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-500/10 flex items-center justify-center">
            <i className="ri-smartphone-line text-2xl text-primary-400"></i>
          </div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50 mb-3">
            随时随地追黑料
          </h2>
          <p className="text-sm text-foreground-400 mb-6 max-w-md mx-auto leading-relaxed">
            51黑料网适配移动端浏览，无论你在通勤路上还是午休时间，打开手机即可获取黑料每日更新，今日黑料最新动态一秒不落。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a href="#topics" className="w-full sm:w-auto px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-semibold rounded-md text-sm transition-all whitespace-nowrap cursor-pointer">
              <i className="ri-compass-3-line mr-2"></i>
              进入黑料入口
            </a>
            <span className="text-xs text-foreground-600 whitespace-nowrap">
              无需下载 · 浏览器直接访问
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}